module.exports = __webpack_public_path__ + "img/Icon_Link.3608ccb9.svg";